module.exports = __webpack_public_path__ + "images/Undo.4fc0b682efdb2b1a500eae85030755b8.svg";